module.exports = __webpack_public_path__ + "img/icon-schedule.cfbc0544.svg";